import { render } from "./BasicBtn.vue?vue&type=template&id=649dced1"
import script from "./BasicBtn.vue?vue&type=script&lang=js"
export * from "./BasicBtn.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./BasicBtn.vue?vue&type=style&index=0&id=649dced1&lang=scss&module=b"
cssModules["b"] = style0

import exportComponent from "/usr/share/nginx/production/musubisumu/tex/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__